import { createHelpers } from 'vuex-map-fields';

const { getReductionField, updateReductionField } = createHelpers({
    getterType: `getReductionField`,
    mutationType: `updateReductionField`,
});

const state = {
    reduction : {
        positions:[],
        date_from: '01-01-2000 23:00:00',
        reduction:
            {reduction:{
                    tender_date_to: '01-01-2000 23:00:00'
                }}
    },

    tender_item_id : 0,

    positions: [],
    users: [],

    locked: []

};

const getters = {
    getReductionField,

    getUsers(state) {
        return state.users;
    },

    getReduction(state) {
        return state.reduction;
    },

    getHistory(state) {
        return state.reduction.reduction?.reduction_history || [];
    }
};

const mutations = {
    updateReductionField,
    SET_TENDER: (state, payload) => {
        state.reduction = {...payload};
    },
    SET_LOCKED: (state, payload) => {
        state.locked = payload;
    },

    SET_USERS: (state, payload) => {
        state.users = payload;
    },

};

const actions = {
    GET_TENDER: async (context, payload) => {
        await axios.get('/internal/reduction/tender/' + payload)
            .then(response => {
                context.commit('SET_TENDER', response.data.data);
            })
            .finally(() => {
                IMC_CORE.hideloading()
            })
            .catch(error => {
                console.log(error);
            });
    },

    GET_USERS: async (context, payload) => {
        await axios.get('/internal/reduction/users/' + payload)
            .then(response => {
                context.commit('SET_USERS', response.data.data);
            })
            .catch(error => {
                console.log(error);
            });
    },

    GET_LOCKED: async (context, payload) => {
        await axios.get('/internal/reduction/locked/' + payload)
            .then(response => {
                context.commit('SET_LOCKED', response.data.data);
            })
            .catch(error => {
                console.log(error);
            });
    },

};


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
